import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatOptionSelectionChange} from '@angular/material/core';
import {EortcQlqResults, Q_EORTC_QLQ} from '../../../../model/questionnaires/questionnaire-eortc-qlq';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../store/app.states';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questionnaire-eortc-qlq-c30',
  templateUrl: './questionnaire-eortc-qlq.component.html',
  styleUrls: ['./questionnaire-eortc-qlq.component.css']
})
export class QuestionnaireEortcQlqComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_EORTC_QLQ;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = ['1', '2', '3', '4'];
  values2q: string[] = ['1', '2', '3', '4', '5', '6', '7'];
  results = [];

  /// toolbar
  back = true;
  title = 'EORTC-QLQ';
  destination = '/questionnaires';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              private store: Store<AppState>,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router) { }

  ngOnInit(): void {

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      this.results[position - 1] = value;
      console.log(this.results);
    }
  }

  onSubmit() {

    this.submitted = true;
    this.show = true;

    if (this.results.length < this.dataSource.length) {
      this.show = false;
      this.submitted = false;

      const msg = 'Non hai finito di completare il questionario!';
      this.openDialog(msg);
    } else {

      let count = 0;

      for (const r of this.results) {
        if (r === null) {
          count++;
        }
      }

      // tslint:disable-next-line:max-line-length
      if ((count === 2 && this.results[this.results.length - 1] === null && this.results[this.results.length - 2] === null) || (count === 0)) {
          const res = [];
          this.results.forEach(r => res.push(parseInt(r, 10)));
          console.log(res);
          const resultToSend = new EortcQlqResults(this.doctorID, this.patientSSN, res);
          this.questionnaireService.sendForm(resultToSend, 'eortc-qlq', this.uuid);
      } else {
        this.show = false;
        this.submitted = false;
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
      }
    }
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
